export default __webpack_public_path__ + "static/media/regalxDemo_downloadMT4.0875ddc1.png";